
import moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { PlacementGroupDiaryList } from '@/api/openapi';
import Pagination from '@/components/Pagination.vue';
import { parsePagination } from '@/utils';

@Component({
  components: { Pagination },
})
export default class GroupDiary extends Vue {
  @Prop() readonly id!: string;

  @Action displayError!: (s: string) => void;
  @Action displaySuccess!: (s: string) => void;
  @Getter loggedInUserHasAnyPermission: any;

  data: Array<PlacementGroupDiaryList> | null = null;
  loading: boolean = true;
  pagination: any | null = null;
  today = moment().format('YYYY-MM-DD');

  async loadList(page?: number, limit?: number) {
    const variables = {
      page: page || undefined,
      limit: limit || 5,
      placementGroup: this.id,
    };

    this.loading = true;
    this.data = [];

    try {
      const response = await this.$placementApi.placementGroupDiaryList(variables);

      this.data = response.data;

      this.pagination = parsePagination(response);
    } catch (e) {
      this.$log.error(e);
      this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
    } finally {
      this.loading = false;
    }
  }

  changeLimit(limit: number) {
    this.loadList(undefined, limit);
  }

  changePage(page: number) {
    this.loadList(page, this.pagination.currentLimit);
  }

  async created() {
    this.loadList();
  }
}
